<template>
  <div class="container">
    <div v-if="!serverAvailable">
      <h1 style="color: brown">Server Under Maintnance... <br />服务器维护中。。。</h1>

      <el-button
        id="refreshBtn"
        type="success"
        v-loading="isLoading"
        @click="handleRefresh"
      >
        Refresh
      </el-button>
    </div>

    <el-form v-else :model="form" label-width="auto" style="max-width: 800px">
      <el-form-item label-position="left" label="行数 (Number of rows)">
        <el-input-number
          v-model="form.rows"
          :min="1"
          :max="10"
          @change="handleChange"
          style="width: 150px"
        />
      </el-form-item>

      <el-form-item label-position="left" label="表头 (Headers)">
        <el-button-group style="margin-right: 10px">
          <el-button :color="buttonColor" @click="handleRemoveHeader"> - </el-button>
          <el-button :color="buttonColor" @click="handleAddHeader"> + </el-button>
        </el-button-group>

        <!-- 1 ~ 5 headers -->
        <el-input
          v-for="(header, index) in form.headers"
          :key="index"
          v-model="form.headers[index]"
          style="margin: 5px 0; width: 100px"
        />
      </el-form-item>

      <el-form-item label-position="left" label="生成模板 (Template)">
        <el-tooltip class="box-item" title="Template 说明" placement="right">
          <template #content>
            Template 与 Headers 中的表头一一对应。
            <br />
            TEXT(): 将想要放置在单元格中的字符数据放到 TEXT() 中，
            例如、TEXT(测试)。TEXT()中的内容可以是中文、英文等和数字字符，
            它们不会随着单元格的生成发生改变。
            <br />
            NUM(): 将想要放置在单元格中的整数数据放到 NUM() 中, 例如、NUM(1)
            。NUM()中的数字会随着行数的增加而增加。
            <br />
          </template>
          <el-button :color="buttonColor" size="small" type="info" circle>?</el-button>
        </el-tooltip>
      </el-form-item>

      <TemplateRow
        v-for="(tmp, index) in form.template"
        :key="index"
        :index="index"
        :header="form.headers[index]"
        :templateStr="form.template[index]"
        @remove-template-item="handleRemoveHeader"
        @new-template-str="handleNewTemplateStr"
        @disable-generate="handleDisableGenerate"
      >
      </TemplateRow>

      <el-form-item>
        <el-button
          id="generateBtn"
          type="primary"
          style="margin-right: 10px"
          :disabled="disableGenerate"
          :color="buttonColor"
          v-loading="isLoading"
          @click="handleGenerateExcel"
        >
          生成 Excel
        </el-button>
        <RouterLink to="/contact">
          <el-button type="info"> 生成更多行数据 </el-button>
        </RouterLink>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import request from "@/utils/request";
import TemplateRow from "./TemplateRow.vue";

export default {
  name: "ExcelFakerPage",
  components: { TemplateRow },
  async created() {
    // Test to seed if server is running
    request({
      method: "get",
      url: "/info",
    })
      .then((response) => {
        if (response.status === 200) {
          this.serverAvailable = true;
        }
      })
      .catch((error) => {
        console.error("Error fetching initial data:", error);
      });
  },
  async mounted() {},
  data: function () {
    return {
      disableGenerate: false,
      templateChangeCounter: 0,
      buttonColor: "#626aef",
      serverAvailable: false,
      isLoading: false,
      form: {
        rows: 5,
        headers: ["Name", "Age", "Notes"],
        template: ["TEXT(ABC)NUM(10000)", "NUM(10)", "TEXT(HelloWorld)"],
      },
    };
  },
  methods: {
    handleChange: function (value) {
      console.log("handleChange", value);
    },
    handleAddHeader: function () {
      console.log("handleAddHeader");
      if (this.form.headers.length < 5) {
        this.form.headers.push("Header" + (this.form.headers.length + 1));
        this.form.template.push("");
      }
    },
    handleRemoveHeader: function () {
      console.log("handleRemoveHeader");
      if (this.form.headers.length > 1) {
        this.form.headers.pop();
        this.form.template.pop();
      }
    },
    handleDisableGenerate: function () {
      this.templateChangeCounter++;
      this.disableGenerate = true;
      console.log("Disable Generate Button");
    },
    handleNewTemplateStr: function (data) {
      // { idx: index, val: newTemplateStr }, from child component
      this.form.template[data.idx] = data.val;
      this.templateChangeCounter--;
      if (this.templateChangeCounter <= 0) {
        this.disableGenerate = false;
      }
    },
    handleGenerateExcel: function () {
      //Timeout button for 10 seconds
      this.isLoading = true;

      // 使用 this.$axios 发起 GET 请求
      request({
        method: "post",
        url: "/excelfaker",
        responseType: "arraybuffer", // 设置响应类型为 arraybuffer
        data: {
          rows: this.form.rows,
          headers: this.form.headers,
          template: this.form.template,
        },
      })
        .then((response) => {
          // 将响应数据赋值给 title
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          link.setAttribute("download", "out.xlsx"); //or any other extension
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          this.isLoading = false; // 停止加载状态
        })
        .catch((error) => {
          console.log(error);
          // Status 412, Too frequent requests
          if (error.response && error.response.status === 412) {
            this.$message({
              message: "请求过于频繁，请稍后再试。",
              type: "warning",
            });
          } else {
            this.$message({
              message: "生成 Excel 失败，请稍后再试。",
              type: "error",
            });
          }
          this.isLoading = false; // 停止加载状态
        });
    },

    handleRefresh: function () {
      this.isLoading = true;

      request({
        method: "get",
        url: "/sign",
        params: { data: navigator.userAgent },
      })
        .then((response) => {
          if (response.status === 200) {
            if (response.data) {
              localStorage.setItem("jwtToken", response.data);
            }
            this.isLoading = false;
            this.serverAvailable = true;
          }
        })
        .catch((error) => {
          console.error("Error fetching initial data:", error);
          this.isLoading = false;
        });
    },
  },
};
</script>

<style scoped>
.container {
  position: relative;
  background: rgba(231, 231, 231, 0.7);
  overflow: scroll;
  height: 80vh;
  -ms-overflow-style: none; /* for Internet Explorer, Edge */
  scrollbar-width: none; /* for Firefox */
  overflow-y: scroll;
  color: rgb(47, 35, 35);
  padding: 20px;
}
</style>
